const nonCharacterRegex = /([^a-z0-9])/g;
const duplicatedHyphensRegex = /-+/g;
const startEndHyphensRegex = /(^-)|(-$)/g;
const capitalCharacterRegex = /([A-Z])/g;

export default {
  inject: ['$validator'],
  props: {
    displayName: {
      type: String,
      required: true,
    },
    identifier: {
      type: String,
      default: '',
    },
    validations: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    errorMessages() {
      return (this.errors && this.errors.collect)
        ? this.errors.collect(this.inputIdentifier)
        : [];
    },
    inputIdentifier() {
      if (this.identifier) {
        return this.identifier;
      }

      return this.displayName
        .replace(capitalCharacterRegex, '-$1')
        .toLowerCase()
        .replace(nonCharacterRegex, '-')
        .replace(duplicatedHyphensRegex, '-')
        .replace(startEndHyphensRegex, '');
    },
    modelValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
